import Vue from 'vue'

// limitar tamanho do texto  {{ text | truncate(100) }}
let VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

// filtros numericos
import './numeric'

// filtros com data
import './date'

// FILTROS PARA TEXTOS
import './text'

// PARA FORMULÁRIOS COMO INPUT ERRO
import './forms'

// filtro para imagens
import './img'

// PARA FILTRAR ARRAYS DE DADOS
import './arrayFilter'

// FILTROS PARA TAMANHO DE COMPONENTES E FOTOS
// import './tamanhos'



// WEBPACK FOOTER //
// ./resources/assets/js/filters/index.js